
import { defineComponent, PropType, SetupContext,  onMounted, ref } from "vue";
import { PantryFridgeRoomData, PantryFridgeAreaImageData, FridgeCameraRoomInfo } from "@/types/pantry";
import store from "@/store";
import PantryImageRoomItem from "./PantryImageRoomItem.vue";
import PantryImageEmptyView from "./PantryImageEmptyView.vue";
import NativeClient from "@/client/native-client";
import PantryUtil from "@/utils/pantry-util";
import CommonUtil from "@/utils/common-utils";
export default defineComponent({
  name: "PantryImageRoomHorizontalView",
  components: {
    PantryImageRoomItem,
    PantryImageEmptyView
  },
  props: {
    roomId: {
      type: Number,
      defalut: -1
    },
    room: {
      type: PantryFridgeRoomData,
      default: null
    },
    imageUpdate: {
      type: Boolean,
      default: false
    },
    cameraRoomInfo: {
      type: FridgeCameraRoomInfo,
      default: null,
      required: true
    },
    isSelect: {
      type: Boolean,
      default: false,
      required: true
    },
    applianceId: {
      type: String,
      default: null,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    const updateDisplayKey = ref(0);
    const updateDisplay = () => {
      if (updateDisplayKey.value >= 100) {
        updateDisplayKey.value = 0;
      } else {
        updateDisplayKey.value++;
      }
    };
    const getImages = () => {
      const areaList = new Array<PantryFridgeAreaImageData>();
      NativeClient.sendDebugLog("PantryImageRoomHorizontalView getImages roomId=" + props.roomId + " room=" + JSON.stringify(props.room));
      if (props.room) {
        NativeClient.sendDebugLog("PantryImageRoomHorizontalView getImages roomId=" + props.room.roomId);
        NativeClient.sendDebugLog(
          "PantryImageRoomHorizontalView getImages map result=" + CommonUtil.jsonStringify(props.room.areaMap)
        );
        const areaIdList = PantryUtil.getAreaIdList(props.room.roomId, props.cameraRoomInfo.reizoDoorTypeId);
        if (areaIdList != null) {
          for (const id of areaIdList) {
            const areaData = props.room.areaMap.get(id);
            if (areaData != null) {
              areaList.push(areaData);
            }
          }
        }
      }
      NativeClient.sendDebugLog("PantryImageRoomHorizontalView getImages roomId=" + props.roomId + " areaList=" + JSON.stringify(areaList));
      return areaList;
    };
    const onSelectImage = (roomId: number, areaId: number, fileName: string) => {
      NativeClient.sendDebugLog("PantryImageRoomHorizontalView onSelectImage");
      context.emit("select-image", roomId, areaId, fileName);
    };
    const isEmpty = () => {
      const result = props.room.areaMap && props.room.areaMap.size == 0;
      NativeClient.sendDebugLog("PantryImageRoomHorizontalView isEmpty roomId=" + props.roomId + " result=" + result);
      return result;
    };
    const isNoData = () => {
      const result = props.room == null;
      NativeClient.sendDebugLog("PantryImageRoomHorizontalView isNoData roomId=" + props.roomId + " result=" + result );
      return result;
    };
    const completeLoadCamaraImage = (roomId: number) => {
      store.dispatch("common/stopLoading");
      updateDisplay();
    };
    const setFridgeImageUrlList = async (roomId: number, applianceId: string) => {
      NativeClient.sendDebugLog("PantryImageRoomHorizontalView setFridgeImageUrlList applianceId=" + applianceId + " roomId=" + roomId);
      const fridgeRoomId = PantryUtil.getFridgeRoomId(roomId);
      const success = PantryUtil.setFridgeImageUrlListMap(roomId, fridgeRoomId, applianceId);
      NativeClient.sendDebugLog("PantryImageRoomHorizontalView setFridgeImageUrlList applianceId=" + applianceId + " roomId=" + roomId + " success=" + success);
      if (success) {
        const images = props.room.getImageList();
        PantryUtil.requestImageLoad(roomId, images, applianceId, completeLoadCamaraImage);
      } else {
        store.dispatch("common/stopLoading");
      }
    };
    const requestFridgeListResult = async (roomId: number, applianceId: string) => {
      setFridgeImageUrlList(roomId, applianceId);
    };
    const requestFridgeListParamResult = async (roomId: number, applianceId: string) => {
      PantryUtil.requestFridgeList(roomId, applianceId, requestFridgeListResult);
    };
    const execute = async () => {
      NativeClient.sendDebugLog("PantryImageRoomHorizontalView execute roomId=" + props.roomId);
      NativeClient.sendDebugLog("PantryImageRoomHorizontalView execute isSelect=" + props.isSelect);
      NativeClient.sendDebugLog("PantryImageRoomHorizontalView execute room=" + JSON.stringify(props.room));
      NativeClient.sendDebugLog("PantryImageRoomHorizontalView execute applianceId=" + props.applianceId);
      if (props.room && props.isSelect && props.roomId != undefined) {
        const images = props.room.getImageList();
        NativeClient.sendDebugLog("PantryImageRoomHorizontalView execute");
        const isCompelete = PantryUtil.isCompeleteLoadImageData(images);
        NativeClient.sendDebugLog("PantryImageRoomHorizontalView execute isCompelete=" + isCompelete);
        if (!isCompelete) {
          store.dispatch("common/startLoading");
          PantryUtil.requestFridgeListParam(props.roomId, props.applianceId, requestFridgeListParamResult)
        }
      }
    };
    const onShowDate = (roomId:number, areaId: number) => {
      const selectId = PantryUtil.getSelectId(roomId, areaId, props.room);
      const dateList = PantryUtil.getDateList(roomId, areaId, props.room);
      if (selectId != -1 && dateList.length != 0) {
        context.emit("show-date", roomId, areaId, selectId, dateList);
      }
    };

    /**
     * コンポーネントがマウントされたときに通知される
     */
    onMounted(async () => {
      execute();
    });
    return {
      getImages,
      onSelectImage,
      isEmpty,
      isNoData,
      updateDisplayKey,
      onShowDate
    }
  }
});
